import React from 'react';
import ABC from '../../assets/ABC.svg';
import './Loading.scss';

export default () =>
  (
    <div className='loading'>
      <img src={ABC} alt='Atlantic Blockchain Company Logo' />
    </div>
  );